import { render, staticRenderFns } from "./EditableCard.vue?vue&type=template&id=ec58e272&"
import script from "./EditableCard.vue?vue&type=script&lang=js&"
export * from "./EditableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports